import { finish, error } from '../../../modules/user/actions/cancel-withdrawal';

import api from '../../../api';

export function request(dispatch, action) {
    api.request('DELETE', '/user/withdrawals/' + action.id).then(
        ({ data }) => dispatch(finish(data)),
        ({ errors }) => dispatch(error(errors))
    );
}
